import React from 'react';

import { Wrapper, DayWrapper } from './styles';

const Day = ({ name, value, ...rest }) => (
  <DayWrapper {...rest} data-value={value}>
    {name}
  </DayWrapper>
);

export default function WeekDays({ value, setValue, ...rest }) {
  const handleClick = (e) => {
    const targetValue = parseInt(e.target.dataset.value);
    setValue(value.map((one, idx) => (idx === targetValue ? !one : one)));
  };

  return (
    <Wrapper {...rest}>
      <Day name="M" value={1} onClick={handleClick} isActive={value[1]} />
      <Day name="T" value={2} onClick={handleClick} isActive={value[2]} />
      <Day name="W" value={3} onClick={handleClick} isActive={value[3]} />
      <Day name="T" value={4} onClick={handleClick} isActive={value[4]} />
      <Day name="F" value={5} onClick={handleClick} isActive={value[5]} />
      <Day name="S" value={6} onClick={handleClick} isActive={value[6]} />
      <Day name="S" value={0} onClick={handleClick} isActive={value[0]} />
    </Wrapper>
  );
}
